// removed by extract-text-webpack-plugin
module.exports = {"root":"_1etJxtHbgRteCztNgGCQob","header":"_3ZsV5IE661mB09YF-zFRBU","headerSearch":"hJjLndz097jWqgstyEGHg","searchBox":"_35lM9SC0MhnCZ030wcFd1w","searchBoxWrapper":"MdpUwzaaAVyAcN7WaoRQY","iconMenu":"_2NX6J7_C5picIRMIvMupbw","imgIcon":"_11ejWbPfpIpKWrVhpg5sCJ","imgIconOpen":"_1dzGqQJPHWcuDdKgpAVMBn _11ejWbPfpIpKWrVhpg5sCJ","openIcon":"_32vvcqb_lr6nyfKyo5ikXw _2NX6J7_C5picIRMIvMupbw","item":"NVFpEn6FWwe42tF2hJ28a","logo":"bCQkOekdKvBqU6lAmfCuf","logoWrapper":"_2R-G9VdemFGdGkUuq9E7E3","appBody":"_1Eyg4GnThgBLIwh8kdrIhI","headerMenu":"_2NVb22IcvGHblzzcHzqZsK","mainMenu":"_2RNOou-b8tuq9c_FuJ2UOK"};


//////////////////
// WEBPACK FOOTER
// ./src/views/App/style.css
// module id = 1082
// module chunks = 0